export default {
  sv: {
    greeting: 'Hej',
    subtitle: 'Här hittar du dina kommande och tidigare bokningar.',
    bookings: 'Bokningar',
    conversations: 'Ärenden',
    contactUs: 'Kontakta oss',
    upcomingBookings: 'Kommande bokningar',
    pastBookings: 'Tidigare bokningar',
    noUpcoming: 'Du har inga kommande bokningar.',
    noPast: 'Du har inga tidigare bokningar.',
    cancel: 'Avboka',
    cancelling: 'Avbokar...',
    cancelTitle: 'Avboka besök',
    cancelConfirm: 'Är du säker på att du vill avboka',
    cancelKeep: 'Behåll bokning',
    cancelYes: 'Ja, avboka',
    cancelled: 'Avbokad',
    cancelTooLate: 'Avbokning kan göras senast 24 timmar före besöket.',
    operationCancel: 'Behöver du avboka/omboka din operation?',
    operationContact: 'Kontakta oss på',
    rebookQuestion: 'Behöver du omboka din tid?',
    rebookContact: 'Kontakta oss på',
    rebookOr: 'eller',
    contactIntro: 'Här kontaktar du oss för sjukvårdsrelaterade frågor inför eller efter din operation. För övriga frågor och bokning, kontakta oss på',
    contactUrgent: 'Vid akuta tillstånd utanför våra svarstider, vänligen kontakta vårt journummer eller vänd dig till 1177 för rådgivning.',
    accountInfo: 'Kontoinformation',
    email: 'E-post',
    emailNotSet: 'Ej angiven',
    change: 'Ändra',
    save: 'Spara',
    cancelAction: 'Avbryt',
    logout: 'Logga ut',
    newContact: 'Skapa nytt ärende',
    emailPrompt: 'För att vi ska kunna se tidigare historik och skicka notiser vid nya meddelanden behöver vi din e-postadress.',
    emailPlaceholder: 'E-postadress',
    conversationsTitle: 'Konversationer',
    newConv: 'Nytt',
    noConversations: 'Du har inte några tidigare konversationer.',
    closed: 'Stängd',
    startedOn: 'Startades',
    done: 'Klart!',
    ticketCreated: 'Ditt ärende har skapats. Vi återkommer så fort som möjligt.',
    createNew: 'Skapa nytt ärende',
    selectClinic: 'Välj klinik',
    selectType: 'Välj ärendetyp',
    selectSubType: 'Välj undertyp',
    messages: 'Meddelanden',
    reply: 'Svara',
    replyPlaceholder: 'Skriv ditt svar...',
    send: 'Skicka',
    messagePlaceholder: 'Skriv ditt meddelande...',
    attachFile: 'Bifoga fil',
    back: 'Tillbaka',
    yourBooking: 'ditt besök',
    on: 'den',
    selectConversation: 'Välj ett ärende till vänster för att se konversationen.',
    ticketClosed: 'Ärendet är stängt',
    loggedInAs: 'INLOGGAD SOM',
    myPages: 'Mina sidor',
  },
  en: {
    greeting: 'Hi',
    subtitle: 'Here you can find your upcoming and past bookings.',
    bookings: 'Bookings',
    conversations: 'Messages',
    contactUs: 'Contact us',
    upcomingBookings: 'Upcoming bookings',
    pastBookings: 'Past bookings',
    noUpcoming: 'You have no upcoming bookings.',
    noPast: 'You have no past bookings.',
    cancel: 'Cancel',
    cancelling: 'Cancelling...',
    cancelTitle: 'Cancel booking',
    cancelConfirm: 'Are you sure you want to cancel',
    cancelKeep: 'Keep booking',
    cancelYes: 'Yes, cancel',
    cancelled: 'Cancelled',
    cancelTooLate: 'Cancellations must be made at least 24 hours before the appointment.',
    operationCancel: 'Need to cancel/reschedule your operation?',
    operationContact: 'Contact us at',
    rebookQuestion: 'Need to reschedule your appointment?',
    rebookContact: 'Contact us at',
    rebookOr: 'or',
    contactIntro: 'Here you can contact us regarding healthcare-related questions before or after your surgery. For other questions and bookings, contact us at',
    contactUrgent: 'For urgent matters outside our office hours, please contact our on-call number or reach out to 1177 for advice.',
    accountInfo: 'Account information',
    email: 'Email',
    emailNotSet: 'Not set',
    change: 'Change',
    save: 'Save',
    cancelAction: 'Cancel',
    logout: 'Log out',
    newContact: 'Create new ticket',
    emailPrompt: 'To view your history and receive notifications for new messages, we need your email address.',
    emailPlaceholder: 'Email address',
    conversationsTitle: 'Conversations',
    newConv: 'New',
    noConversations: 'You have no previous conversations.',
    closed: 'Closed',
    startedOn: 'Started',
    done: 'Done!',
    ticketCreated: 'Your ticket has been created. We will get back to you as soon as possible.',
    createNew: 'Create new ticket',
    selectClinic: 'Select clinic',
    selectType: 'Select ticket type',
    selectSubType: 'Select sub-type',
    messages: 'Messages',
    reply: 'Reply',
    replyPlaceholder: 'Write your reply...',
    send: 'Send',
    messagePlaceholder: 'Write your message...',
    attachFile: 'Attach file',
    back: 'Back',
    yourBooking: 'your booking',
    on: 'on',
    selectConversation: 'Select a conversation on the left to view messages.',
    ticketClosed: 'This ticket is closed',
    loggedInAs: 'LOGGED IN AS',
    myPages: 'My pages',
  }
};
